import { render, staticRenderFns } from "./DeliveryHowItWorksLine02.vue?vue&type=template&id=0aa64a34&"
import script from "./DeliveryHowItWorksLine02.vue?vue&type=script&lang=js&"
export * from "./DeliveryHowItWorksLine02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports